import { useQuery } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';

type UseDosages = {
  drugId?: number;
};

export const useDosages = ({ drugId }: UseDosages) => {
  const dosagesQuery = useQuery({
    queryKey: DrugsQueryKeys.fetchDosages(drugId),
    queryFn: () => {
      if (drugId) {
        return DrugsApi.fetchDosages(drugId);
      }
    },
    staleTime: Infinity,
  });

  const { data } = dosagesQuery;
  const dosages = data?.items;

  return {
    ...dosagesQuery,
    dosages,
  };
};
